(function () {
  // The hero video loops well past five seconds, so running it for someone
  // who asked for reduced motion is the WCAG 2.2.2 failure. The markup
  // deliberately omits `autoplay` and playback is driven from here instead,
  // which also avoids the frame-and-stop flicker of pausing after the fact —
  // when the video never starts, the poster image stays up.
  const videos = document.querySelectorAll('video[data-autoplay]');

  if (!videos.length) {
    return;
  }

  // Tracked rather than read once: the preference can be toggled while the
  // page is open, and motion should stop then, not at the next reload.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncPlayback() {
    videos.forEach(function (video) {
      if (reducedMotion.matches) {
        video.pause();

        return;
      }

      const started = video.play();

      // Browsers refuse autoplay in their own cases too; the poster covers it.
      if (started && typeof started.catch === 'function') {
        started.catch(function () {});
      }
    });
  }

  reducedMotion.addEventListener('change', syncPlayback);
  syncPlayback();
})();
